export enum OtpActions {
	VERIFY_EMAIL = "VERIFY_EMAIL",
	VERIFY_PHONE = "VERIFY_PHONE",
	FORGOT_PASSWORD = "FORGOT_PASSWORD",
	TERMINATE_ACCOUNT = "TERMINATE_ACCOUNT",
	CHANGE_PASSWORD = "CHANGE_PASSWORD",
}
